import React from 'react'
import { Badge, Icon } from 'gu-ui-kit'
import { useTranslation } from 'react-i18next'
import PropTypes from 'prop-types'

const STATUS = {
  active: {
    icon: 'status active',
    color: 'Label-Confirm',
    bgColor: 'Background-Confirm',
    label: 'advertisers::filters.dropdown.items.status.options.active',
  },
  archived: {
    icon: 'inbox-archive',
    color: 'Label-Fifth',
    bgColor: 'Background-Quaternary',
    label: 'advertisers::filters.dropdown.items.status.options.archived',
  },
}

export const StatusBadge = ({ status = null, ...rest }) => {
  const currentStatus = STATUS?.[status]
  const { t } = useTranslation()

  if (!currentStatus) {
    return null
  }

  const { icon, label, bgColor, color } = currentStatus

  return (
    <Badge
      {...rest}
      bgColor={bgColor}
      color={color}
      startIcon={<Icon color={color} name={icon} width={16} />}
    >
      {t(label)}
    </Badge>
  )
}

StatusBadge.propTypes = {
  status: PropTypes.string,
  className: PropTypes.string,
  component: PropTypes.elementType,
}
